import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getMarginBottomClass, marginBottomLevels } from '../../utils/marginBottom/index.js';
import Theme from '../../utils/Theme.js';
import styles from './heading.css.js';
var Heading = forwardRef(function (_ref, ref) {
  var component = _ref.component,
      accentBar = _ref.accentBar,
      children = _ref.children,
      level = _ref.level,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? level < 4 ? 4 : 2 : _ref$marginBottom,
      rest = _objectWithoutProperties(_ref, ["component", "accentBar", "children", "level", "marginBottom"]);

  var Component = component || "h".concat(level);
  return React.createElement(Component, _extends({
    className: cn(styles['Heading'], styles["Heading--".concat(level)], accentBar && Theme.name === 'redbrand' ? styles['Heading--accentBar'] : '', getMarginBottomClass(marginBottom)),
    tabIndex: "-1",
    ref: ref
  }, rest), children);
});
Heading.displayName = 'Heading';
Heading.propTypes = process.env.NODE_ENV !== "production" ? {
  accentBar: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  children: PropTypes.node.isRequired,
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).isRequired,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels)
} : {};
export default Heading;